import { SELECT_EMPTY_FILE, SELECT_FILE } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').SystemPermission} SystemPermission
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @template A
 * @typedef {import('../types/reducer').DataRepairer<A>} DataRepairer
 */

/**
 * @type {SystemPermission}
 */
const INITIAL_STATE = { permission: null }

/**
 * @param {DataRepairer<any>} _dataRepairers
 * @return {function(SystemPermission, PltrAction): SystemPermission}
 */
const permissionReducer =
  (_dataRepairers) =>
  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case SELECT_FILE: {
        return {
          permission: action.permission,
        }
      }
      case SELECT_EMPTY_FILE: {
        return {
          permission: null,
        }
      }
      default:
        return state
    }
  }

export default permissionReducer
